(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polarpicks-dinosaur"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-dino-timer]').forEach(timer => {
  const hours = timer.querySelector('[data-timer-hours]');
  const minutes = timer.querySelector('[data-timer-minutes]');
  const seconds = timer.querySelector('[data-timer-seconds]');
  const updateTimer = () => {
    const cycle = 43200000;
    const remaining = Math.ceil((cycle - Date.now() % cycle) / 1000);
    hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
    minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
    seconds.textContent = String(remaining % 60).padStart(2, '0');
    timer.hidden = false;
  };
  updateTimer();
  const interval = setInterval(() => {
    if (!timer.isConnected) { clearInterval(interval); return; }
    updateTimer();
  }, 1000);
});
document.querySelectorAll('.dino-gallery').forEach(gallery => {
  gallery.querySelectorAll('[data-dino-image]').forEach(button => {
    button.addEventListener('click', () => {
      gallery.querySelector('.dino-main').src = button.dataset.dinoImage;
      gallery.querySelectorAll('[data-dino-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  });
});
document.querySelectorAll('.dino-form').forEach(form => {
  const quantity = form.querySelector('[name="quantity"]');
  const choices = form.querySelectorAll('[name="dino_bundle"]');
  const price = form.closest('.dino-buy').querySelector('[data-dino-price]');
  const updatePrice = () => {
    const count = Number(quantity.value);
    if (!Number.isInteger(count) || count < 1 || count > 100) return;
    choices.forEach(choice => choice.checked = Number(choice.value) === count);
    const total = count * 399 - (count >= 3 ? 298 : count === 2 ? 149 : 0);
    price.textContent = new Intl.NumberFormat('sv-SE', {style:'currency',currency:'SEK'}).format(total);
  };
  choices.forEach(choice => choice.addEventListener('change', () => { quantity.value = choice.value; updatePrice(); }));
  quantity.addEventListener('input', updatePrice);
});

  } catch(e) { console.error(e); }
})();
})();
